// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function FundModelRequestFromJSON(json) {
    return {
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'fundId': json['fundId'],
        'investorAccountId': !exists(json, 'investorAccountId') ? undefined : json['investorAccountId'],
        'strategy': !exists(json, 'strategy') ? undefined : json['strategy'],
        'assetClass': !exists(json, 'assetClass') ? undefined : json['assetClass'],
    };
}
export function FundModelRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'requestId': value.requestId,
        'fundId': value.fundId,
        'investorAccountId': value.investorAccountId,
        'strategy': value.strategy,
        'assetClass': value.assetClass,
    };
}
